export default __webpack_public_path__ + "static/media/night.ac6d287d.jpg";